var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-4",staticStyle:{"background":"#1976d2","color":"white"},on:{"click":_vm.logout}},[_vm._v(" Logout "),_c('v-icon',{staticStyle:{"padding-left":"0.5vw"},attrs:{"left":""}},[_vm._v("mdi-logout-variant")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }